import { useLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import type { FeatureFlagsType } from '@lotta/self-service/lottery-fe/util-feature-flags';
import { FeatureFlagContext } from '@lotta/self-service/lottery-fe/util-feature-flags';
import { Outlet } from 'react-router-dom';
import { environment } from '../environments/environment';

const isEnabled = (retailUnit: string, configuredRetailUnits: string[]) => {
  return configuredRetailUnits.includes('ALL') || configuredRetailUnits.includes(retailUnit);
};

export const FeatureFlags: React.FC = () => {
  const { retailUnit } = useLocale();
  const {
    PURCHASE_MARKETS,
    SWIPE_MARKETS,
    SIMPLE_SIGNUP_MARKETS,
    PURCHASE_AND_SIMPLE_SIGNUP_MARKETS,
    REQUIRE_EMAIL_MARKETING_CONSTRAINT,
    MINIMUM_PURCHASE_AMOUNT,
  } = environment;
  const featureFlags: FeatureFlagsType = {
    swipe: isEnabled(retailUnit, SWIPE_MARKETS),
    purchase: isEnabled(retailUnit, PURCHASE_MARKETS),
    simpleSignup: isEnabled(retailUnit, SIMPLE_SIGNUP_MARKETS),
    purchaseAndSimpleSignup: isEnabled(retailUnit, PURCHASE_AND_SIMPLE_SIGNUP_MARKETS),
    requireEmailMarketingConstraint: isEnabled(retailUnit, REQUIRE_EMAIL_MARKETING_CONSTRAINT),
    minimumPurchaseAmount: isEnabled(retailUnit, MINIMUM_PURCHASE_AMOUNT),
  };
  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      <Outlet />
    </FeatureFlagContext.Provider>
  );
};
